<script>
  import { Globe } from 'lucide-svelte';

  export let iconClass = '';
</script>

<Globe class={iconClass} />